import { render, staticRenderFns } from "./RandomPaper.vue?vue&type=template&id=8b42cf1e&scoped=true&"
import script from "./RandomPaper.vue?vue&type=script&lang=js&"
export * from "./RandomPaper.vue?vue&type=script&lang=js&"
import style0 from "./RandomPaper.vue?vue&type=style&index=0&id=8b42cf1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b42cf1e",
  null
  
)

export default component.exports